import GitInfo from 'react-git-info/macro';

import {config} from '../config/env';

const getRelativeTime = (commitDateStr: string) => {
  const now = new Date();
  const commitDate = new Date(commitDateStr);
  const diffMs = now.getTime() - commitDate.getTime();

  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ['year', diffMs / (1000 * 60 * 60 * 24 * 365)],
    ['month', diffMs / (1000 * 60 * 60 * 24 * 30)],
    ['day', diffMs / (1000 * 60 * 60 * 24)],
    ['hour', diffMs / (1000 * 60 * 60)],
    ['minute', diffMs / (1000 * 60)],
    ['second', diffMs / 1000]
  ];

  const rtf = new Intl.RelativeTimeFormat('en', {numeric: 'auto'});

  for (const [unit, value] of units) {
    if (Math.abs(value) >= 1) {
      return rtf.format(-Math.floor(value), unit);
    }
  }
  return 'just now';
};

export const getBuildInfo = () => {
  try {
    const git = GitInfo();
    const tag = git.tags?.length ? git.tags.join(' ') : '';
    return `Build: ${tag} #${git.commit.shortHash}, ${getRelativeTime(git.commit.date)} for ${config.SENTRY_ENV}`;
  } catch {
    return '';
  }
};

export const getVersion = (): string | null => {
  try {
    const url = new URL(window.location.href);
    const versionParam = url.searchParams.get('version');

    if (!versionParam) {
      return null;
    }

    const isProdEnv = config.SENTRY_ENV === 'production';
    const isQAEnv = config.SENTRY_ENV === 'qa';

    const gitInfo = GitInfo();
    const tags = gitInfo?.tags || [];

    if (tags.length === 0) {
      return null;
    }

    const prefix = isProdEnv ? 'release' : isQAEnv ? 'qa' : 'dev';
    const version = tags.find((tag) => tag.startsWith(prefix)) || tags[0];

    return version || null;
  } catch (error) {
    return null;
  }
};
